module.exports = __webpack_public_path__ + "img/showcase-3.7043bec0.png";